export default __webpack_public_path__ + "static/media/cardCheckMark.8dda9fa4.svg";